<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>统计</el-breadcrumb-item>
          <el-breadcrumb-item>订单记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-row>
            <el-col :span="3"> <el-input placeholder="单据号" v-model="queryParam.billNumber" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="会员编号" v-model="queryParam.number" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="商家名称" v-model="queryParam.merchantName" size="small" clearable></el-input></el-col>
            <el-col :span="8" style="margin-left:5px">
              <el-date-picker
                v-model="queryParam.date"
                size="small" 
                type="daterange"
                align="right"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"                
                end-placeholder="结束日期"
                @change="dateSelect"
                >
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="margin-left:5px"><el-button type="primary" v-on:click="Search" size="small" >查询</el-button></el-col>
          </el-row>
        </el-form>
        <el-table :data="items" style="width: 100%" :row-class-name="getRowClass">
          <el-table-column  prop="children" fixed="left" label="" type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.Children" border fit highlight-current-row>
                <el-table-column prop="Name" label="名称" sortable></el-table-column>
                <el-table-column prop="OriginalPrice" label="原价"></el-table-column>
                <el-table-column prop="Price" label="优惠金额"></el-table-column>
                <el-table-column prop="Number" label="数量"></el-table-column>
                <el-table-column prop="Attach" label="备注"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column  prop="BillNumber" :show-overflow-tooltip="true" fixed="left" label="单据号"></el-table-column>
          <el-table-column  prop="MerchantName"  :show-overflow-tooltip="true"  label="商家名称"> </el-table-column>
          <el-table-column  prop="MemberName"  label="会员名称"> </el-table-column>
          <el-table-column  prop="PaidInfo_ReceivableAmount"  label="应收金额"> </el-table-column>
          <el-table-column  prop="PaidInfo_ReceiptAmount"  label="实收金额"  > </el-table-column>
          <el-table-column  prop="PaidInfo_WxPaid"  label="微信支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_AliPaid"  label="支付宝支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_PointPaid"  label="积分支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_ValuePaid"  label="储值支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_CashPaid"  label="现金支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_RewardPaid"  label="奖励金支付"  > </el-table-column>
          <el-table-column  prop="UserAccount"  label="操作员"   ></el-table-column>
          <el-table-column  prop="CreateTime"  width="140px" label="操作时间" :show-overflow-tooltip="true"> </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam: {
          pageIndex: 1,
          pageSize: 10,
          sort: ' CreateTime desc ',
          totalCount:10,
          billNumber:'',
          number:'',
          merchantName:'',
          beginTime:'',
          endTime:'',
          date:''
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{
      getRowClass: function (row,rowIndex) {
        if(row.row.Children.length==0){  //判断当前行是否有子数据或者根据实际情况设置
          return 'row-expand-cover'
        }
      },
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Statistical/OrderNote',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      },
      dateSelect(picker){
        if(picker==null){
          this.queryParam.beginTime = ''
          this.queryParam.endTime = ''
        }else{
          this.queryParam.beginTime = picker[0]
          this.queryParam.endTime = picker[1]
        }
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.el-table .row-expand-cover .cell .el-table__expand-icon {
  display: none;
}

</style>